import { render, staticRenderFns } from "./ChiefMandateSwitches.vue?vue&type=template&id=6293c45c"
import script from "./ChiefMandateSwitches.vue?vue&type=script&lang=js"
export * from "./ChiefMandateSwitches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports